export function initLaboV2(){

	var Labo = Barba.BaseView.extend({
	namespace: 'laboratoire-v2',
	onEnter: function() {
		// The new Container is ready and attached to the DOM.

        // Fix positionning after BarbaJS loading.
        
        // we get #cta-tag-labo element
        var elem_taglabo = document.querySelector('#cta-tag-labo');
        elem_taglabo.remove();
        // we cut it...
        // we paste it after the footer...
        document.body.appendChild(elem_taglabo);
	},
	onEnterCompleted: function() {
        // The Transition has just finished.
        const lang = document.querySelector('.barba-container').dataset.lang;
        if (lang === 'fr') {
            hbspt.forms.create({
                region: "na1",
                portalId: "5159010",
                target: "#formcontainer",
                formId: "5f9219aa-95b3-496d-8b9c-9a530eb2ccdc",
                redirectUrl:"https://www.supratec-syneo.com/merci-laboratoire.html?success=true"
            });
        }  else  {
            hbspt.forms.create({
                region: "na1",
                portalId: "5159010",
                target: "#formcontainer",
                formId: "5946dfb0-b59c-48da-9405-acda5206f480",
                redirectUrl:"https://www.supratec-syneo.com/thanks-laboratory.html?success=true"
            });
        }

        window.addEventListener('message', event => {
            if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
                // console.log('onFormSubmit')
                dataLayer.push({
                    'event': 'Page Labo v2 - soumission de formulaire',
                    'clicID': 'Soumission de formulaire'
                });
            }
        });
	},
    onLeave: function() {
        // A new Transition toward a new page has just started.

        // we get #cta-tag-labo element
        var elem_taglabo = document.querySelector('#cta-tag-labo');

        // we cut it...
        // we paste it after the footer...
        elem_taglabo.remove();
    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
  });

  // Don't forget to init the view!
  Labo.init();



}
